import { Injectable } from "@angular/core";
import {
  Router,
  CanActivate,
  ActivatedRouteSnapshot,
  RouterStateSnapshot,
} from "@angular/router";
import { PermissionEnum } from "../model/permission-enum";
import { HomeComponent } from "../components/home/home.component";
import { AuthenticationService } from "../services/authentication.service";
import { LoginPromptService } from "../services/login-prompt.service";
import { EmployeeInterfaceComponent } from "../components/employee-interface/employee-interface.component";
import { AnalyticsComponent } from "../components/analytics/analytics.component";
import { CourtBookingsComponent } from "../components/court-bookings/court-bookings.component";
import { ManualBookComponent } from "../components/manual-book/manual-book.component";
import { FixedBookingComponent } from "../components/fixed-booking/fixed-booking.component";
import { MatchConfirmationsComponent } from "../components/match-confirmations/match-confirmations.component";
import { SystemAlertsComponent } from "../components/system-alerts/system-alerts.component";
import { ApproveMatchesComponent } from "../components/approve-matches/approve-matches.component";
import { NewRegistrationsComponent } from "../components/new-registrations/new-registrations.component";
import { TournamentCreateComponent } from "../components/tournament-create/tournament-create.component";
import { TournamentManageComponent } from "../components/tournament-manage/tournament-manage.component";

@Injectable({ providedIn: "root" })
export class AuthGuard implements CanActivate {
  constructor(
    private router: Router,
    private authenticationService: AuthenticationService,
    private loginPromptService: LoginPromptService,
  ) {}

  async canActivate(route: ActivatedRouteSnapshot, state: RouterStateSnapshot) {
    await this.authenticationService.waitForInitialization();

    const currentUser = this.authenticationService.currentUserValue;
    if (currentUser) {
      let permissions = this.authenticationService.currentUserPermissions;
      let hasPlayerPermission = permissions.some(
        (permission: PermissionEnum) => permission == PermissionEnum.Player,
      );
      let hasAdminPermission = permissions.some(
        (permission: PermissionEnum) => permission == PermissionEnum.Admin,
      );

      const adminComponents = [
        EmployeeInterfaceComponent,
        AnalyticsComponent,
        CourtBookingsComponent,
        ManualBookComponent,
        FixedBookingComponent,
        MatchConfirmationsComponent,
        SystemAlertsComponent,
        ApproveMatchesComponent,
        NewRegistrationsComponent,
        TournamentCreateComponent,
        TournamentManageComponent,
      ];

      if (adminComponents.some((c) => route.component === c)) {
        if (!hasAdminPermission) {
          if (hasPlayerPermission) {
            this.router.navigate(["/home"]);
          } else {
            this.router.navigate(["/login"]);
          }
          return false;
        }
      }

      switch (route.component) {
        case HomeComponent:
          if (hasAdminPermission) {
            this.router.navigate(["/employee-interface"]);
            return false;
          }
          if (!hasPlayerPermission) {
            this.router.navigate(["/clubs"]);
            return false;
          }
          break;
      }

      return true;
    }

    this.router.navigate(["/clubs"]);
    setTimeout(() => {
      this.loginPromptService.show(
        "Please log in to access this feature",
        state.url,
      );
    }, 100);
    return false;
  }
}
